module.exports = __webpack_public_path__ + "img/Controller-Vive-Left-Description.4a0877d1.svg";